import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppState } from '../../../reducers';

@Component({
  standalone: false,
  selector: 'dsp-additional-authentication',
  templateUrl: 'additional-authentication.component.html'
})
export class AdditionalAuthenticationComponent implements OnInit {
  public form: FormGroup;
  public phone = '(***)***-5555';

  public constructor(
    private readonly store: Store<AppState>
  ) {}

  public ngOnInit(): void {
    this.form = new FormGroup({
      security: new FormControl('', [ Validators.required ])
    });
  }

  public onConfirm(): void {}

  public onResend(): void {}
}
